"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWorldCharacterPosition = void 0;
const WorldCharacter_1 = require("../classes/WorldCharacter");
const getConstants_1 = require("./getConstants");
const definables_1 = require("definables");
const pixel_pigeon_1 = require("pixel-pigeon");
const updateWorldCharacterPosition = (characterID, position) => {
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, characterID);
    worldCharacter.position = position;
    const constants = (0, getConstants_1.getConstants)();
    (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.entityID, {
        x: position.x * constants["tile-size"],
        y: position.y * constants["tile-size"],
    });
};
exports.updateWorldCharacterPosition = updateWorldCharacterPosition;
